// JSON-LD goes into the page as the text of a <script> element, and the HTML
// parser ends that element at the first "</script" it meets. JSON.stringify
// leaves "<" alone, so a post title, bio or description carrying
// "</script><script>..." would close the block and run as page script for
// every visitor (the API stores titles and details as typed).
//
// Writing <, > and & as \u escapes keeps the JSON value identical for every
// JSON-LD reader and leaves the HTML parser nothing to end the element on.
// U+2028 and U+2029 are escaped too: legal inside JSON strings, but line
// terminators to older JavaScript parsers.
export function jsonLdHtml(value: unknown): string {
  return JSON.stringify(value)
    .replace(/</g, '\\u003c')
    .replace(/>/g, '\\u003e')
    .replace(/&/g, '\\u0026')
    .replace(/\u2028/g, '\\u2028')
    .replace(/\u2029/g, '\\u2029');
}
